import React from "react"
import styled from "styled-components"
import { Link, Logo } from "@life-without-barriers/react-components"
import { youthPinkLight } from "@life-without-barriers/react-components/src/Variables"

const LinkedDesktopLogo = ({ className }: { className: string }) => (
  <Link className={className} title="Life Without Barriers" to="/">
    <Logo
      type="lwbInline"
      height="25"
      width="333"
      primarycolor={youthPinkLight}
    />
  </Link>
)

const LinkedMobileLogo = ({ className }: { className: string }) => (
  <Link className={className} title="Life Without Barriers" to="/">
    <Logo
      type="lwbInline"
      height="16"
      width="215"
      primarycolor={youthPinkLight}
    />
  </Link>
)

const Header = () => (
  <Container className="ph3 ph4-l overflow-hidden">
    <LinkedDesktopLogo className="pv3 dn inline-flex-l" />
    <LinkedMobileLogo className="pv3 flex dn-l" />
  </Container>
)

const Container = styled.div`
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 5;
`

export default Header
